import ApiService from "../ApiService";
const { REACT_APP_REST_ENDPOINT } = process.env;

export default class ContenutiUtentiService {

    static verificaStatoContenuto = (data) => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/contenuti-utenti/verifica-stato-new`;
            ApiService.postRequest(resolve, reject, url, data)
        });
    }

    static iniziaContenuto = (data) => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/contenuti-utenti/inizia`;
            ApiService.postRequest(resolve, reject, url, data)
        });
    }

    static verificaCompletamenti = (data) => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/contenuti-utenti/verifica-completamenti`;
            ApiService.postRequest(resolve, reject, url, data)
        });
    }
    
    static getUrl = (data) => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/contenuti-utenti/get-url-new`;
            ApiService.postRequest(resolve, reject, url, data)
        });
    }

    static salvaTest = (data) => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/contenuti-utenti/salva-test-new`;
            ApiService.postRequest(resolve, reject, url, data)
        });
    }
}